import { render } from "./MoreNotices.vue?vue&type=template&id=3ac67c2e&scoped=true"
import script from "./MoreNotices.vue?vue&type=script&lang=js"
export * from "./MoreNotices.vue?vue&type=script&lang=js"

import "./MoreNotices.vue?vue&type=style&index=0&id=3ac67c2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac67c2e"]])

export default __exports__